import {kioskReload} from "../../../services/louah-kiosk";
import {annualEventConfirmation} from "../../../components/annualEventConfirmation";
import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FormEditorRender from "../../../components/WebEditor/form";
import {Button, Result, Spin, Typography} from "antd";
import {ASSET_URL} from "../../../config";
import {applyI18n, applyLang} from "../../../i18n";
import Loader from "../loader";
import FormMultiDevise from "../../../components/FormMultiDevise";
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"
import logger from "../../../services/logger"

const {Text} = Typography

export default class FormPage extends Component{

    state={
        submit:false,
        loading:true,
        formData:null,
        accessId:null
    }

    componentDidMount() {
        this.setState({loading:false})

        const context=this.props.context
        let accessId=context.query.accessId || context.query.a

        if(accessId){
           this.setState({accessId:accessId})
        }
    }

    submitRender() //DEFAULT TEMP
    {
        const context=this.props.context
        const {org,config,data}=context

        const form=data[0]
        const formData=this.state.formData

        return(
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",marginTop:100}}>
                <Result
                    status="success"
                    title={t`Votre formulaire a bien été reçu.`}
                    subTitle={<>{annualEventConfirmation(this.props.context.data?.[0], this.props.context) && <p style={{whiteSpace:"pre-line"}}>{annualEventConfirmation(this.props.context.data?.[0], this.props.context)}</p>}{this.state.ticketsUrl ? t`Vos billets sont prêts : présentez-les à l'entrée.` : t`Il sera traité dans les meilleurs délais.`}</>}
                    extra={[
                        // Billets émis à la validation : lien vers la page « mes billets ».
                        this.state.ticketsUrl && <Button key="tickets" type="primary" href={this.state.ticketsUrl}><Trans>Voir mes billets</Trans></Button>,
                        <Button key="reset" type={this.state.ticketsUrl ? "default" : "primary"} onClick={()=>kioskReload()}><Trans>Soumettre un nouveau formulaire</Trans></Button>,
                    ].filter(Boolean)}
                />
            </div>
        )
    }

    render(){
        const context=this.props.context
        const {org,config,data}=context

        logger.debug({ data }, "data")

        const form=applyI18n(data[0],context)
        if(form.products){
            form.products=form.products.map(p=>applyI18n(p,context))
        }

        let lang=context.langValue
        const languages=context.org.languages || []
        if(languages.length>0 && !lang){
            lang=context.org.language
        }

        const title=form.title
        const description=form.description

        const metaTitle=form.metaTitle || title
        const metaDescription=form.metaDescription || description
        const metaImage=form.metaImage?ASSET_URL+form.metaImage:null

        let extra= {}
        if(this.state.accessId){
            extra.accessId=this.state.accessId
        }

        if(org.virtualId){
            extra.virtualId=org.virtualId
        }

        let isActive=true
        if(!form.active || form.expired || (form.expireAt && new Date(form.expireAt).getTime()<new Date().getTime())){
            isActive=false
        }


        if(this.props.loading){
            return (
                <div>
                    <Meta context={context} seo={form} title={metaTitle} description={metaDescription} image={metaImage}/>
                    <Loader/>
                </div>
            )
        }


        return(
            <div className={"travel-page travel-page--home"}>
                <Meta context={context} seo={form} title={metaTitle} description={metaDescription} image={metaImage}/>
                <Header context={context}/>

                {context.render !== "embed" && title && (
                    <header className="tr-form__header">
                        <h1 className="tr-form__title">{title}</h1>
                        {description && (
                            <p className="tr-form__subtitle">{description}</p>
                        )}
                    </header>
                )}

                <style dangerouslySetInnerHTML={{ __html: `
                    .tr-form__header {
                        text-align: center;
                        padding: clamp(24px, 4vw, 48px) clamp(16px, 4vw, 32px) 8px;
                        max-width: 820px;
                        margin: 0 auto;
                    }
                    .tr-form__title {
                        margin: 0;
                        font-size: clamp(24px, 4vw, 40px);
                        font-weight: 800;
                        color: #1a1a2e;
                        line-height: 1.15;
                        letter-spacing: -.01em;
                        text-wrap: balance;
                    }
                    .tr-form__subtitle {
                        margin: 10px auto 0;
                        font-size: 16px;
                        color: #6b7280;
                        line-height: 1.5;
                        max-width: 640px;
                    }
                `}} />

                {isActive && (
                    <div>
                        <FormMultiDevise context={context} form={form} />
                        <Spin spinning={this.state.loading}>
                            <div style={context.render !== "embed"?{marginTop: 20,minHeight:"80vh"}:undefined}>

                                {!this.state.submit &&(
                                    <FormEditorRender
                                        form={form}
                                        lang={lang}
                                        onLoading={(loading)=>this.setState({loading})}
                                        onSubmit={(formData,result)=>this.setState({loading:false,submit:true,formData:formData,ticketsUrl:result?.ticketsUrl||null})}
                                        extra={Object.keys(extra).length>0?extra:null}
                                        org={org}
                                    />
                                )}

                                {this.state.submit && this.submitRender()}

                            </div>
                        </Spin>
                    </div>
                )}

                {!isActive && (
                    <div style={{minHeight:"50vh",display:"flex",justifyContent:"center",alignItems:"center"}}>
                       <Result
                            style={{maxWidth:600}}
                            status={"warning"}
                            title={t`Ce formulaire est expiré !`}
                            subTitle={t`Vous ne pouvez pas remplir ce formulaire pour le moment, pour toute question contactez directement votre responsable.`}
                            extra={context.render !== "embed"?(
                                <Button href={org.BASE_WEB_URL}><Trans>Retourner à la page d'accueil</Trans></Button>
                            ):undefined}
                       />
                    </div>
                )}

                <Footer context={context}/>
            </div>
        )
    }
}
